import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { DEFAULT_TASKS_SEARCH, type TasksSearch } from '@/components/tasks/tasks-search-schema'
import { TasksWorkspace } from '@/components/tasks/tasks-workspace'
import { oneOf, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/taches')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /**
         * La vue : « Regarde le Gantt de ce client » se partage, elle vit donc
         * dans l'URL. Les autres filtres restent locaux.
         */
        vue: oneOf(['liste', 'kanban', 'gantt'] as const),
      },
      search,
    ),
  component: ClientTasksPage,
})

function ClientTasksPage() {
  const client = useShellClient()
  const { vue } = Route.useSearch()
  const navigate = Route.useNavigate()
  const [filters, setFilters] = useState<TasksSearch>(() => ({ ...DEFAULT_TASKS_SEARCH }))
  return (
    <Frame>
      <TasksWorkspace
        search={{ ...filters, vue: vue ?? 'liste' }}
        fixedClient={{ id: client.id, name: client.name }}
        onSearchChange={(next) => {
          if (next.vue !== undefined && next.vue !== vue) {
            void navigate({ search: { vue: next.vue } })
          }
          setFilters((current) => ({ ...current, ...next, page: next.page ?? 1 }))
        }}
      />
    </Frame>
  )
}
